export const trialFormURL =
  'https://script.google.com/macros/s/AKfycbze0Adv9dvUEIqoWEqoevMSqfdYZEBjnDb2m4dKxgQZgyoHt5Kkc6eiDdqtxAEdpgAB5A/exec';

export const conceptFeedbackURL =
  'https://script.google.com/macros/s/AKfycbx28RSdGbsjv6HF74pFb3ckJjjRn_VVtn_gABLfSkN1-DcGaEo-6dtwfDkaPI1TI8FU/exec';
